<div class="card mb-3 slb-header">
  <div class="card-body">
    <div class="row justify-content-between align-items-center">
      <div class="col-sm-auto mb-2 mb-sm-0">
        <h6 class="mb-0 text-white">
          Showing {{ startItem }}-{{ endItem }} of {{ filteredProducts.length }} Products
        </h6>
      </div>

      <div class="col-sm-auto d-flex align-items-center flex-wrap">
        <input type="text"
               class="form-control form-control-sm mr-2 mb-2 mb-sm-0"
               placeholder="Search by name, group, code or price..."
               [(ngModel)]="searchText"
               (ngModelChange)="onSearchChange()"
               style="width: 250px;" />

        <form class="d-inline-block mr-2 mb-2 mb-sm-0">
          <div class="input-group input-group-sm d-flex align-items-center">
            <small class="mr-1">Group: </small>
            <select class="custom-select"
                    [(ngModel)]="selectedGroupId"
                    name="selectedGroupId"
                    (change)="onGroupChange()"
                    aria-label="Group filter">
              <option value="">All Groups</option>
              <option *ngFor="let group of itemGroups; trackBy: trackByGroup"
                      [value]="group.groupId">
                {{ group.groupName }}
              </option>
            </select>
          </div>
        </form>

        <button type="button"
                class="btn btn-sm btn-falcon-default mr-2 mb-2 mb-sm-0"
                (click)="clearGroupFilter()"
                *ngIf="selectedGroupId">
          Clear
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body">
    <div class="row">

      <div class="mb-4 col-md-6 col-lg-3" *ngFor="let p of pagedProducts; trackBy: trackByProduct">
        <div class="border rounded h-100 d-flex flex-column justify-content-between pb-3">
          <div class="overflow-hidden">
            <div class="position-relative rounded-top overflow-hidden">

              <a class="d-block cursor-pointer" href="javascript:void(0)">
                <img class="img-fluid rounded-top" [src]="p.img" loading="lazy" alt=""  style="object-fit: cover; cursor:pointer;" (error)="onImageError($event)" (click)="openImagePreview(p.img)"/>
              </a>
              <span class="badge badge-pill badge-slb position-absolute r-0 t-0 mt-2 mr-2 z-index-2">
                {{ p.itemCode }}
              </span>
            </div>

            <div class="p-3">
              <h5 class="fs--1">
                <a class="text-dark" href="javascript:void(0)">{{ p.itemName }}</a>
              </h5>

              <p class="fs--1 mb-3">
                <a class="text-500"href="javascript:void(0)">{{ p.groupName }}</a>
              </p>

              <div class="d-flex align-items-center justify-content-between">
                <h5 class="fs-md-2 text-primary mb-0 d-flex align-items-center">
                  {{ p.price  | number:'1.2-2'}} <span> ₼</span>
                </h5>

                <p class="fs--1 mb-1">
                  Stock: <strong class="text-success">Available</strong>
                </p>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between px-3">
            <div class="pr-0">
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <button class="btn btn-sm btn-outline-secondary border-300"
                        (click)="decreaseQty(p)"
                          type="button">
                    -
                  </button>
                </div>

                <input class="form-control text-center input-quantity input-spin-none"
                       type="number"
                       min="0"
                       [(ngModel)]="p.orderQty"
                       style="max-width: 50px">

                <div class="input-group-append">
                  <button class="btn btn-sm btn-outline-secondary border-300"
                        (click)="increaseQty(p)"
                          type="button">
                    +
                  </button>
                </div>
              </div>
            </div>

            <div>
              <a class="btn btn-sm btn-falcon-default"
                 href="javascript:void(0)"
                 (click)="addToCart(p)">
                <span class="fas fa-cart-plus"></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center py-4" *ngIf="filteredProducts.length === 0">
        <h6 class="mb-0 text-muted">No products found.</h6>
      </div>

    </div>
  </div>

  <div class="card-footer bg-light d-flex justify-content-center" *ngIf="filteredProducts.length > 0">
    <div>
      <button class="btn btn-falcon-default btn-sm mr-2"
              type="button"
              [disabled]="currentPage === 1"
              (click)="prevPage()"
              title="Prev">
        <span class="fas fa-chevron-left"></span>
      </button>

      <a *ngFor="let page of pages"
         class="btn btn-sm mr-2"
         href="javascript:void(0)"
         [ngClass]="page === currentPage ? 'btn-falcon-default text-primary' : 'btn-falcon-default'"
         (click)="goToPage(page)">
        {{ page }}
      </a>

      <button class="btn btn-falcon-default btn-sm"
              type="button"
              [disabled]="currentPage === totalPages"
              (click)="nextPage()"
              title="Next">
        <span class="fas fa-chevron-right"></span>
      </button>
    </div>
  </div>
</div>
<div class="modal fade" id="imagePreviewModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">

      <div class="text-right p-2">
        <button class="btn btn-sm btn-light"
                data-dismiss="modal">
          ✕
        </button>
      </div>

      <div class="text-center p-2">
        <img [src]="selectedImage"
             class="img-fluid rounded shadow"
             style="max-height: 80vh; object-fit: contain;">
      </div>

    </div>
  </div>
</div>
